module.exports = __webpack_public_path__ + "files/9d560a826d389ca36d46285684f2acdf.png";